import FormatCurrency from 'components/Common/FormatCurrency'
import { useAppSelector } from 'hooks/reduxHooks'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import SolidTagAltIcon from 'LuxKit/Icons/solid/SolidTagAltIcon'
import { getCanRedeemLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

function LuxPlusMonthLandingPageOfferMessageBanner() {
  const isLuxPlusMember = useAppSelector(getCanRedeemLuxPlusBenefits)
  const subscriptionProduct = useAppSelector(state => state.luxPlus.products.subscription)
  const offer = useMemo(() => subscriptionProduct.offers?.find(offer => !offer.joinFeeWaived), [subscriptionProduct.offers])

  if (isLuxPlusMember || !offer) return null

  const joiningFee = offer?.joinFee ?? 0

  return <MessageBanner
    kind="promotional-primary"
    align="center"
    icon={<SolidTagAltIcon />}
  >
    <FormattedMessage
      id="XV-ZvHddpkMSnJyoJMG4"
      defaultMessage="<b>Special offer:</b> No joining fee when you purchase an eligible LuxPlus+ offer. <b>{amount} value</b>"
      description="Special offer banner about waived joining fee for eligible LuxPlus+ offers"
      values={{
        b: (chunks) => <b>{chunks}</b>,
        amount: <FormatCurrency value={joiningFee} />,
      }}
    />
  </MessageBanner>
}

export default LuxPlusMonthLandingPageOfferMessageBanner
